<template>
  <BenefitItem
    v-for="(type, index) in benefitTypeList"
    :key="type + index"
    :type="type"
    :icons="icons"
  >
    <template #luxury>
      <slot name="luxury" />
    </template>

    <template #virtuoso>
      <slot name="virtuoso" />
    </template>
  </BenefitItem>
</template>

<script setup>
import { computed } from "vue";

import BenefitItem from "./BenefitItem.vue";
const props = defineProps({
  benefits: {
    type: Array,
    default: () => []
  },
  icons: {
    type: Object,
    default: () => ({})
  }
});
const benefitTypeList = computed(() => {
  const _benefits = props.benefits.reduce(
    (acc, current) => {
      if (!acc.map.has(current.type)) {
        acc.map.set(current.type, true);
        acc.result.push(current);
      }
      return acc;
    },
    { map: new Map(), result: [] }
  ).result;
  const _list = _benefits.map(item => item.type);
  return _list.sort((a, b) => {
    return a[0].charCodeAt(0) - b[0].charCodeAt(0);
  });
});
</script>

<style lang="scss" scoped>
img {
  width: 123px;
  height: 24px;
}
</style>
